import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding:40,textAlign:'center'}}>
          <div style={{fontSize:48,marginBottom:16,opacity:0.3}}>⚠️</div>
          <h3 style={{color:'#dc2626',marginBottom:8}}>오류가 발생했습니다</h3>
          <p style={{color:'#64748b',fontSize:14,marginBottom:16}}>{this.state.error && this.state.error.toString()}</p>
          <button onClick={function(){window.location.reload()}} style={{padding:'8px 24px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:8,cursor:'pointer',fontSize:14}}>새로고침</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
